import type { SubscriptionRunStatus } from '@/types';

/**
 * The status vocabulary shared by StatusPill and StatusFilterBar. Kept in a
 * module of its own because Vite only keeps fast refresh for files that export
 * nothing but components.
 */

const pillClasses: Record<SubscriptionRunStatus, string> = {
  Success: 'pill-success',
  Failed: 'pill-failed',
  Disabled: 'pill-disabled',
  Pending: 'pill-pending',
  Stale: 'pill-stale',
  Unknown: 'pill-unknown'
};

/** Shared with the status filter chips so a status keeps one colour everywhere. */
export function statusPillClass(status: SubscriptionRunStatus) {
  return pillClasses[status];
}

/**
 * Display order for the chips. Unknown is PbirsStatusMapper's catch-all for status
 * text it doesn't recognise, so it sits last rather than first like the enum.
 */
export const statusFilterOrder: SubscriptionRunStatus[] =
  ['Success', 'Failed', 'Disabled', 'Pending', 'Stale', 'Unknown'];

export function isRunStatus(value: string): value is SubscriptionRunStatus {
  return (statusFilterOrder as string[]).includes(value);
}

export function countByStatus(rows: readonly { lastStatus: SubscriptionRunStatus }[]) {
  const counts = new Map<SubscriptionRunStatus, number>();
  for (const row of rows) counts.set(row.lastStatus, (counts.get(row.lastStatus) ?? 0) + 1);
  return counts;
}
